import React from 'react';
import * as Sentry from '@sentry/browser';

interface Props {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

interface State {
  hasError: boolean;
  errorMessage: string;
}

export class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, errorMessage: '' };
  }

  static getDerivedStateFromError(error: unknown): State {
    const msg = error instanceof Error ? error.message : String(error);
    return { hasError: true, errorMessage: msg };
  }

  componentDidCatch(error: unknown, info: React.ErrorInfo) {
    console.error('[ErrorBoundary]', error, info.componentStack);
    if (error instanceof Error) {
      Sentry.captureException(error, { extra: { componentStack: info.componentStack } });
    }
  }

  handleReset = () => {
    this.setState({ hasError: false, errorMessage: '' });
  };

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) return this.props.fallback;

      return (
        <div
          style={{
            minHeight: '50vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '1rem',
            padding: '2rem',
            textAlign: 'center',
          }}
        >
          <span style={{ fontSize: '2.5rem' }}>🌌</span>
          <h2
            style={{
              fontFamily: 'var(--font-display)',
              fontSize: '1.25rem',
              color: 'var(--text-primary)',
            }}
          >
            Algo não saiu como planejado
          </h2>
          <p style={{ color: 'var(--text-secondary)', maxWidth: '340px', fontSize: 'var(--text-label)' }}>
            Tente novamente em alguns instantes. Se o problema persistir, atualize a página.
          </p>
          <button className="btn btn-primary" onClick={this.handleReset}>
            Tentar novamente
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}
